import { createSelector } from 'reselect'
import { RootState } from 'Store'
import { LoginResult } from 'types'

export const loginResultSelector = (state: RootState): LoginResult => state.customer.loginResult
export const userIdentifierSelector = (state: RootState): string => state.customer.identifier

export const userTokenSelector = createSelector([loginResultSelector], (loginResult: LoginResult): string => {
  if (!loginResult || !loginResult.user) {
    return ''
  }

  const channels = loginResult.user.channels
  if (!channels) {
    return ''
  }

  const firstChannel = channels[0]
  return firstChannel.token
})

export const isLoggedIn = createSelector([userTokenSelector], (token?: string): boolean => {
  const hasToken = token === '' || token === undefined
  return Boolean(hasToken)
})
